var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { reqGetWhitelistPageList } from "../request/mtdsbase/whitelist/getWhitelistPageList/get.js";
async function getWhiteFilterCodeList(params) {
  const res = await reqGetWhitelistPageList(__spreadProps(__spreadValues({}, params), { pageNo: 1, pageSize: 500 }));
  return res.records.map((item) => item.filterCode);
}
export { getWhiteFilterCodeList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/utils/getWhiteFilterCodeList.js